import { Alert } from '@nimbus-ds/components';
import { usePayorderToPay } from 'domains/Billing/Checkout/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';

export default function DisabledRecurrenciesAlert() {
  const t = useTranslationBilling(
    'checkout.choosePaymentMethodWithRecurrency.disabledRecurrenciesAlert',
  );

  const { isForPlanOnly, isSuccess } = usePayorderToPay();
  if (isForPlanOnly || !isSuccess) return null;

  return <Alert appearance="warning">{t('message')}</Alert>;
}
